
import {defineComponent, reactive, toRefs, onMounted} from 'vue'
import {List} from 'vant'
import {tempFeedbackQuery, lightFeedbackQuery} from "@/apis/portrait";
import {store} from "@/store";
import {useRoute} from "vue-router";
import {formatEnergyDate} from "@/utils";
import { parseImgUrl } from '@/utils'

export default defineComponent({
  components: {
    VanList: List
  },
  setup() {
    const list: any = []
    let dataMap: any = null
    const proxyData = reactive({
      parseImgUrl:parseImgUrl,
      loading: false,
      finished: false,
      dataMap: dataMap,
      noDataFlag: false,
      user: store.state.user,
      page: 1,
      pageCount: 12,
      list: list,
      type: 'temp',
      onLoad() {
        proxyData.getLoadData()
      },
      /**
       * 获取数据列表
       */
      getLoadData() {
        let param: any = {
          "orders": [
            {
              "column": "createTime",
              "asc": false
            }
          ],
          criteria: {
            "projectId": proxyData.user.projectId,
            "userId": proxyData.user.userId
          },
          "page": proxyData.page,
          "size": proxyData.pageCount
        }
        if (proxyData.type === 'temp') {
          param.criteria.itemId = {
            "$in": [1, 2, 3, 4, 5, 6, 10, 12]
          }
          // 温度统计记录
          proxyData.tempFeedbackQuery(param)
        } else {
          // 照明统计记录
          proxyData.lightFeedbackQuery(param)
        }
      },
      formatDataMap(allRes: any) {
        allRes.forEach(function (item: any) {
          const date: any = formatEnergyDate(item.createTime)[0]
          item.showDate = formatEnergyDate(item.createTime)[1]
          item.showTime = formatEnergyDate(item.createTime)[2]
          proxyData.setTempDetail(item)
          if (!proxyData.dataMap) {
            proxyData.dataMap = {}
          }
          if (proxyData.dataMap[date]) {
            proxyData.dataMap[date].push(item)
          } else {
            proxyData.dataMap[date] = [item]
          }
        })
      },
      /**
       *设置温度详情
       */
      setTempDetail(item: any) {
        if (proxyData.type == 'temp') {
          switch (item.itemId) {
            case 1:
            case 2:
              item.details = '空调温度调高';
              break;
            case 3:
            case 4:
              item.details = '空调温度调低';
              break;
            case 5:
              item.details = '空调风量调小';
              break;
            case 6:
              item.details = '空调风量调大';
              break;
            case 10:
              item.details = '关闭空调';
              break;
            case 12:
              item.details = '开启空调';
              break;
          }
        } else {
          item.details = item.onOff ? '照明开启' : '照明关闭';
        }
      },
      /**
       *空调调节记录
       */
      tempFeedbackQuery(param: any) {
        tempFeedbackQuery(param).then(res => {
          const resData: any = res
          const allRes: any = resData?.content ?? []
          proxyData.loading = false
          // 格式化数据，供dom渲染
          proxyData.formatDataMap(allRes)
          if (allRes && allRes.length === 0) {
            proxyData.finished = true
          } else {
            proxyData.page++
          }
          /**
           * 无数据的时候显示
           */
          if (!proxyData.dataMap) {
            proxyData.noDataFlag = true
          }
        })
      },
      /**
       * 照明统计记录
       * @param param
       */
      lightFeedbackQuery(param: any) {
        lightFeedbackQuery(param).then(res => {
          const resData: any = res
          const allRes: any = resData?.content ?? []
          proxyData.loading = false
          // 格式化数据，供dom渲染
          proxyData.formatDataMap(allRes)
          if (allRes && allRes.length === 0) {
            proxyData.finished = true
          } else {
            proxyData.page++
          }
        })
      }
    })
    onMounted(() => {
      let route: any = useRoute()
      proxyData.type = route.query.type
    })
    return {
      ...toRefs(proxyData)
    }
  }
})
